var React = require('react');

function Loading (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"0","y":"0","width":"100","height":"100","fill":"none","className":"bk","key":0}),React.createElement("g",{"key":1},[React.createElement("path",{"d":"M50 15A35 35 0 1 0 74.787 25.213","fill":"none","stroke":"#154f80","strokeWidth":"12px","key":0}),React.createElement("path",{"d":"M50 0L50 30L66 15L50 0","fill":"#154f80","key":1}),React.createElement("animateTransform",{"attributeName":"transform","type":"rotate","from":"0 50 50","to":"360 50 50","dur":"1s","repeatCount":"indefinite","key":2})])]);
}

Loading.defaultProps = {"width":"198px","height":"198px","viewBox":"0 0 100 100","preserveAspectRatio":"xMidYMid","className":"uil-reload"};

module.exports = Loading;

Loading.default = Loading;



// WEBPACK FOOTER //
// ./src/images/icons/loading.svg